<template>
    <div class="container banner row justify-center items-center image" v-if="img">
        <v-img :item="item" :img="img" :key="img.url" :zoom="zoom" :isSport="isSport"></v-img>
    </div>
</template>

<script>
    export default {
        name: 'VBanner',

        props: {
            img: {
                type: Object,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            zoom: {
              default: true,
              type: Boolean
            },
            isSport: {
              default: false,
              type: Boolean
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Banner.vue